import { useTranslation } from 'react-i18next';
import { PERMISSION_ACTIONS, PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';

import {
  Form,
  ICONS,
  Button,
  Typography,
  ButtonsWrapper,
  TYPOGRAPHY_SIZE,
  PLATFORM_THEME_COLORS,
} from '@thinknet-gmbh/platform-common-ui';

import PermissionCheck from 'src/components/permission-check';
import { useUpsertGantts } from 'src/hooks/gantts/upsert-gantts.hook';
import { ICompanyGantt } from 'src/pages/settings/components/company/company.interfaces';
import { GanttFormList } from 'src/pages/settings/components/company/components/company-gantts/components/gantt-form-list';

import { HeaderContainer } from './gantt-edit.styles';

const GanttEdit = ({
  companyId,
  data,
  onCancelEdit,
}: {
  companyId: string;
  data: ICompanyGantt[];
  onCancelEdit: () => void;
}) => {
  const { t } = useTranslation(['common', 'settings']);
  const [form] = Form.useForm();

  const upsertGantts = useUpsertGantts();

  const upsert = (values: any) => {
    upsertGantts({
      variables: {
        payload: values.gantts.map(({ holidayLocation, ...ganttValues }: any) => ({
          ...ganttValues,
          companyId,
        })),
      },
      onCompleted: onCancelEdit,
    });
  };

  return (
    <Form layout="vertical" onFinish={upsert} form={form}>
      <Form.List name="gantts" initialValue={data}>
        {(fields, { add, remove }) => (
          <div>
            <HeaderContainer>
              <Typography size={TYPOGRAPHY_SIZE.medium} weight="bold">
                {t('common:labels.gantt')}
              </Typography>
              <PermissionCheck
                action={PERMISSION_ACTIONS.update}
                permission={PLATFORM_PERMISSIONS.permissionGroup}
              >
                <Button
                  type="primary"
                  ghost
                  onClick={() => add()}
                  icon={ICONS.plus}
                  iconColor={PLATFORM_THEME_COLORS.primary.blue}
                >
                  {t('settings:company.buttons.addNewGantt')}
                </Button>
              </PermissionCheck>
            </HeaderContainer>
            <GanttFormList
              cantDeleteLastElement
              fields={fields.map(field => ({
                ...field,
                ...(data[field.name] && { gantt: data[field.name] }),
              }))}
              data={data}
              remove={remove}
              form={form}
            />
          </div>
        )}
      </Form.List>
      <ButtonsWrapper>
        <Button htmlType="submit" type="primary">
          {t('common:buttons.change')}
        </Button>
        <Button onClick={onCancelEdit}>{t('common:buttons.cancel')}</Button>
      </ButtonsWrapper>
    </Form>
  );
};

export default GanttEdit;
